var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon-print",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "20px",
    width: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#969696;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437,129h-14V75c0-41.4-33.6-75-75-75H164c-41.4,0-75,33.6-75,75v54H75c-41.4,0-75,33.6-75,75v120 c0,41.4,33.6,75,75,75h14v68c0,24.8,20.2,45,45,45h244c24.8,0,45-20.2,45-45v-68h14c41.4,0,75-33.6,75-75V204 C512,162.6,478.4,129,437,129z M119,75c0-24.8,20.2-45,45-45h184c24.8,0,45,20.2,45,45v54H119V75z M393,467c0,8.3-6.7,15-15,15H134 c-8.3,0-15-6.7-15-15V319h274V467z M482,324c0,24.8-20.2,45-45,45h-14v-50h9c8.3,0,15-6.7,15-15s-6.7-15-15-15H80 c-8.3,0-15,6.7-15,15s6.7,15,15,15h9v50H75c-24.8,0-45-20.2-45-45V204c0-24.8,20.2-45,45-45h362c24.8,0,45,20.2,45,45V324z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,353h-80c-8.3,0-15,6.7-15,15s6.7,15,15,15h80c8.3,0,15-6.7,15-15S304.3,353,296,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,417h-80c-8.3,0-15,6.7-15,15s6.7,15,15,15h80c8.3,0,15-6.7,15-15S304.3,417,296,417z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,193H80c-8.3,0-15,6.7-15,15s6.7,15,15,15h48c8.3,0,15-6.7,15-15S136.3,193,128,193z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.c5a78f4a9c6331abbb10829c3edeb30a.svg";
export { ForwardRef as ReactComponent };